'use client';

import { useEffect } from 'react';

import { logBuildInfo } from '@web/utils';

interface BuildInfoLoggerProps {
  version: string;
}

export function BuildInfoLogger({ version }: BuildInfoLoggerProps) {
  useEffect(() => {
    logBuildInfo({
      app: 'Net Net',
      version,
      environment: process.env.NEXT_PUBLIC_APP_ENV || 'local',
      commitSha: process.env.NEXT_PUBLIC_COMMIT_SHA || '',
    });
  }, [version]);

  return null;
}
